<template>
  <div class="LKRoadmapsExpertsHeader">
    <div class="table-actions-wrapper">
      <v-btn
        v-if="!readonly"
        :loading="isDeleteLoading"
        color="error"
        outlined
        rounded
        @click="onDeleteClick"
        v-text="'Удалить'"
      />
      <v-spacer />
      <v-btn
        v-if="!readonly"
        :loading="isSaveCloseLoading"
        color="primary"
        outlined
        rounded
        class="ml-btn"
        @click="onSaveCloseClick"
        v-text="'Сохранить и закрыть'"
      />
      <v-btn
        v-if="!readonly"
        :loading="isSaveLoading"
        color="primary"
        outlined
        rounded
        class="ml-btn"
        @click="onSaveClick"
        v-text="'Сохранить'"
      />
      <v-btn
        color="primary"
        outlined
        rounded
        class="ml-btn"
        @click="$emit('close')"
        v-text="'Закрыть'"
      />
    </div>

    <div class="LKRoadmapsExpertsHeader__name" v-text="name" />
  </div>
</template>

<script>
export default {
  name: 'LKRoadmapsExpertsHeader',
  props: {
    name: {
      type: String,
      required: true,
    },
    readonly: Boolean,
  },
  data: () => ({
    isSaveLoading: false,
    isDeleteLoading: false,
    isSaveCloseLoading: false,
  }),
  methods: {
    toggleLoading(what) {
      this[what] = !this[what]
      return this.toggleLoading
    },
    onSaveClick() {
      const callback = () => this.toggleLoading('isSaveLoading')
      this.$emit('save', callback)
    },
    onSaveCloseClick() {
      const callback = () => this.toggleLoading('isSaveCloseLoading')
      this.$emit('save-close', callback)
    },
    onDeleteClick() {
      const callback = () => this.toggleLoading('isDeleteLoading')
      this.$emit('delete', callback)
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKRoadmapsExpertsHeader {
  padding: 1rem;

  &__name {
    margin-top: 20px;
    font-size: 1.375rem;
    font-weight: 700;
    line-height: 1.7875rem;
  }

  @media screen and (max-width: #{800px + 2 * $modal-padding}) {
    flex-wrap: wrap;
    height: auto;
    padding: 10px;
  }

  .table-actions-wrapper {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  .ml-btn {
    margin-left: 12px;
  }

  .form-status {
    margin-top: 10px;
    color: $webflow-color-blue-dark-2;
    text-align: right;
  }
}
</style>
